export default __webpack_public_path__ + "static/media/elements.ce68d6fb.svg";